import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API, getAuthHeader, handleApiError } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Card, CardContent } from '../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Plus, Edit2, Trash2, Shield, Eye, EyeOff, Users, Crown, Check, X, Navigation } from 'lucide-react';

var MODULOS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'ordens_servico', label: 'Ordens de Serviço (Ver)' },
  { key: 'ordens_servico_criar', label: 'OS - Criar' },
  { key: 'ordens_servico_editar', label: 'OS - Editar' },
  { key: 'ordens_servico_excluir', label: 'OS - Excluir' },
  { key: 'ordens_servico_tecnico', label: 'OS - Técnico (Execução)' },
  { key: 'atendimentos', label: 'Atendimentos' },
  { key: 'chat_interno', label: 'Chat Interno' },
  { key: 'mensagens', label: 'Mensagens' },
  { key: 'clientes', label: 'Clientes' },
  { key: 'planos', label: 'Planos' },
  { key: 'filiais', label: 'Filiais' },
  { key: 'boletos', label: 'Boletos' },
  { key: 'financeiro', label: 'Financeiro' },
  { key: 'ixc', label: 'IXCsoft' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'usuarios', label: 'Usuários' },
  { key: 'construtor_menu', label: 'Construtor de Menu (Ver)' },
  { key: 'construtor_menu_criar', label: 'Construtor - Criar' },
  { key: 'construtor_menu_editar', label: 'Construtor - Editar' },
  { key: 'construtor_menu_excluir', label: 'Construtor - Excluir' }
];

function UsuariosPage() {
  var usuariosState = React.useState([]);
  var usuarios = usuariosState[0];
  var setUsuarios = usuariosState[1];
  
  var loadingState = React.useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  
  var modalOpenState = React.useState(false);
  var modalOpen = modalOpenState[0];
  var setModalOpen = modalOpenState[1];
  
  var deleteModalOpenState = React.useState(false);
  var deleteModalOpen = deleteModalOpenState[0];
  var setDeleteModalOpen = deleteModalOpenState[1];
  
  var selectedUsuarioState = React.useState(null);
  var selectedUsuario = selectedUsuarioState[0];
  var setSelectedUsuario = selectedUsuarioState[1];
  
  var showPasswordState = React.useState(false);
  var showPassword = showPasswordState[0];
  var setShowPassword = showPasswordState[1];
  
  var setupLoadingState = React.useState(false);
  var setupLoading = setupLoadingState[0];
  var setSetupLoading = setupLoadingState[1];
  
  var formDataState = React.useState({ 
    name: '', 
    username: '', 
    password: '',
    telefone: '',
    whatsapp_numero: '',
    cargo: '',
    filial_id: '',
    is_super_admin: false,
    permissoes: {
      dashboard: true,
      ordens_servico: false,
      ordens_servico_criar: false,
      ordens_servico_editar: false,
      ordens_servico_excluir: false,
      ordens_servico_tecnico: false,
      atendimentos: false,
      chat_interno: false,
      mensagens: false,
      clientes: false,
      planos: false,
      filiais: false,
      boletos: false,
      financeiro: false,
      ixc: false,
      whatsapp: false,
      usuarios: false,
      construtor_menu: false,
      construtor_menu_criar: false,
      construtor_menu_editar: false,
      construtor_menu_excluir: false,
      rastreio: 'sem_acesso'
    }
  });
  var formData = formDataState[0];
  var setFormData = formDataState[1];

  var CARGOS = [
    { value: 'tecnico', label: 'Técnico' },
    { value: 'atendente', label: 'Atendente' },
    { value: 'financeiro', label: 'Financeiro' },
    { value: 'comercial', label: 'Comercial' },
    { value: 'gerente', label: 'Gerente' },
    { value: 'admin', label: 'Administrador' }
  ];

  var currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  var isSuperAdmin = currentUser.is_super_admin === true;
  var hasSuperAdmin = usuarios.some(function(u) { return u.is_super_admin; });

  React.useEffect(function() { 
    fetchUsuarios(); 
  }, []);

  function fetchUsuarios() {
    setLoading(true);
    axios.get(API + '/users', { headers: getAuthHeader() })
      .then(function(response) { setUsuarios(response.data); })
      .catch(function(error) { handleApiError(error); toast.error('Erro ao carregar usuários'); })
      .finally(function() { setLoading(false); });
  }

  function setupSuperAdmin() {
    setSetupLoading(true);
    axios.post(API + '/users/setup-super-admin', {}, { headers: getAuthHeader() })
      .then(function(response) {
        toast.success(response.data.message);
        // Atualizar localStorage com as novas permissões
        localStorage.setItem('user', JSON.stringify(response.data.user));
        fetchUsuarios();
        window.location.reload();
      })
      .catch(function(error) {
        toast.error(error.response?.data?.detail || 'Erro ao configurar Super Admin');
      })
      .finally(function() { setSetupLoading(false); });
  }

  // Horários de rastreio removidos - Sistema migrado para Traccar

  function openCreateModal() {
    setSelectedUsuario(null);
    setFormData({ 
      name: '', 
      username: '', 
      password: '',
      telefone: '',
      whatsapp_numero: '',
      cargo: '',
      filial_id: '',
      is_super_admin: false,
      permissoes: {
        dashboard: true,
        ordens_servico: false,
        ordens_servico_criar: false,
        ordens_servico_editar: false,
        ordens_servico_excluir: false,
        ordens_servico_tecnico: false,
        atendimentos: false,
        chat_interno: false,
        mensagens: false,
        clientes: false,
        planos: false,
        filiais: false,
        boletos: false,
        financeiro: false,
        ixc: false,
        whatsapp: false,
        usuarios: false
      }
    });
    setShowPassword(false);
    setModalOpen(true);
  }

  function openEditModal(usuario) {
    setSelectedUsuario(usuario);
    setFormData({ 
      name: usuario.name, 
      username: usuario.username, 
      password: '',
      telefone: usuario.telefone || '',
      whatsapp_numero: usuario.whatsapp_numero || '',
      cargo: usuario.cargo || '',
      filial_id: usuario.filial_id || '',
      is_super_admin: usuario.is_super_admin || false,
      permissoes: usuario.permissoes || {
        dashboard: true,
        ordens_servico: false,
        ordens_servico_criar: false,
        ordens_servico_editar: false,
        ordens_servico_excluir: false,
        ordens_servico_tecnico: false,
        atendimentos: false,
        chat_interno: false,
        mensagens: false,
        clientes: false,
        planos: false,
        filiais: false,
        boletos: false,
        financeiro: false,
        ixc: false,
        whatsapp: false,
        usuarios: false,
        rastreio: 'sem_acesso'
      }
    });
    setShowPassword(false);
    setModalOpen(true);
  }

  function togglePermissao(key) {
    var newPermissoes = Object.assign({}, formData.permissoes);
    newPermissoes[key] = !newPermissoes[key];
    setFormData(Object.assign({}, formData, { permissoes: newPermissoes }));
  }

  function toggleAllPermissoes(value) {
    var newPermissoes = {};
    MODULOS.forEach(function(m) {
      newPermissoes[m.key] = value;
    });
    // Manter a permissão de rastreio (não é booleano)
    newPermissoes.rastreio = formData.permissoes.rastreio || 'sem_acesso';
    setFormData(Object.assign({}, formData, { permissoes: newPermissoes }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    
    if (selectedUsuario) {
      // Update
      var updateData = { 
        name: formData.name,
        telefone: formData.telefone,
        whatsapp_numero: formData.whatsapp_numero,
        cargo: formData.cargo,
        filial_id: formData.filial_id,
        is_super_admin: formData.is_super_admin,
        permissoes: formData.permissoes
      };
      if (formData.password) {
        updateData.password = formData.password;
      }
      
      axios.put(API + '/users/' + selectedUsuario.id, updateData, { headers: getAuthHeader() })
        .then(function() {
          toast.success('Usuário atualizado!');
          setModalOpen(false);
          fetchUsuarios();
        })
        .catch(function(err) { 
          toast.error(err.response?.data?.detail || 'Erro ao atualizar'); 
        });
    } else {
      // Create
      if (!formData.password) {
        toast.error('Senha é obrigatória para novo usuário');
        return;
      }
      
      axios.post(API + '/users', formData, { headers: getAuthHeader() })
        .then(function() {
          toast.success('Usuário criado!');
          setModalOpen(false);
          fetchUsuarios();
        })
        .catch(function(err) { 
          toast.error(err.response?.data?.detail || 'Erro ao criar'); 
        });
    }
  }

  function handleDelete() {
    if (!selectedUsuario) return;
    
    axios.delete(API + '/users/' + selectedUsuario.id, { headers: getAuthHeader() })
      .then(function() {
        toast.success('Usuário excluído!');
        setDeleteModalOpen(false);
        setSelectedUsuario(null);
        fetchUsuarios();
      })
      .catch(function(err) { 
        toast.error(err.response?.data?.detail || 'Erro ao excluir'); 
      });
  }

  function countPermissoes(user) {
    if (user.is_super_admin) return 'Todas';
    if (!user.permissoes) return '0';
    var count = 0;
    Object.keys(user.permissoes).forEach(function(key) {
      if (user.permissoes[key]) count++;
    });
    return count + '/' + MODULOS.length;
  }

  return (
    <div className="space-y-6" data-testid="usuarios-page">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <Shield className="w-7 h-7 text-blue-500" />
            Usuários
          </h1>
          <p className="text-slate-500 text-sm">Gerencie usuários e permissões do sistema</p>
        </div>
        <div className="flex gap-2">
          {!hasSuperAdmin && (
            <Button 
              onClick={setupSuperAdmin}
              disabled={setupLoading}
              className="bg-orange-500 hover:bg-orange-600"
              data-testid="setup-super-admin-btn"
            >
              <Crown className="w-4 h-4 mr-2" />
              {setupLoading ? 'Configurando...' : 'Tornar-me Super Admin'}
            </Button>
          )}
          {isSuperAdmin && (
            <Button onClick={openCreateModal} className="bg-blue-600 hover:bg-blue-700" data-testid="add-user-btn">
              <Plus className="w-4 h-4 mr-2" />
              Novo Usuário
            </Button>
          )}
        </div>
      </div>

      {!isSuperAdmin && hasSuperAdmin && (
        <Card className="bg-amber-50 border-amber-200">
          <CardContent className="py-4">
            <p className="text-amber-800 text-sm">
              <strong>🔐 Área restrita:</strong> Apenas o Super Admin pode criar, editar ou excluir usuários.
            </p>
          </CardContent>
        </Card>
      )}

      <Card className="bg-white">
        <CardContent className="p-0">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full" />
            </div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Usuário</TableHead>
                    <TableHead className="hidden sm:table-cell">Nome</TableHead>
                    <TableHead>Cargo</TableHead>
                    <TableHead className="hidden sm:table-cell">Filial</TableHead>
                    <TableHead className="hidden md:table-cell">Telefone/WhatsApp</TableHead>
                    <TableHead className="hidden lg:table-cell">Permissões</TableHead>
                    {isSuperAdmin && <TableHead className="text-right">Ações</TableHead>}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {usuarios.map(function(usuario) {
                    return (
                      <TableRow key={usuario.id}>
                        <TableCell className="font-medium">
                          <div>
                            <p>{usuario.username}</p>
                            <p className="text-xs text-slate-500 sm:hidden">{usuario.name}</p>
                          </div>
                        </TableCell>
                        <TableCell className="hidden sm:table-cell">{usuario.name}</TableCell>
                        <TableCell>
                          {usuario.is_super_admin ? (
                            <span className="inline-flex items-center gap-1 bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs font-medium">
                              <Crown className="w-3 h-3" /> <span className="hidden sm:inline">Super</span> Admin
                            </span>
                          ) : usuario.cargo ? (
                            <span className="inline-flex items-center gap-1 bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium capitalize">
                              {usuario.cargo}
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-1 bg-slate-100 text-slate-600 px-2 py-1 rounded-full text-xs font-medium">
                              <Users className="w-3 h-3" /> <span className="hidden sm:inline">Usuário</span>
                            </span>
                          )}
                        </TableCell>
                        <TableCell className="hidden md:table-cell">
                          <div className="text-sm">
                            {usuario.telefone && <p className="text-slate-600">{usuario.telefone}</p>}
                            {usuario.whatsapp_numero && <p className="text-green-600 text-xs">{usuario.whatsapp_numero}</p>}
                            {!usuario.telefone && !usuario.whatsapp_numero && <span className="text-slate-400">-</span>}
                          </div>
                        </TableCell>
                        <TableCell className="hidden sm:table-cell">
                          {usuario.filial_id === 'passa_quatro' ? (
                            <span className="inline-flex items-center gap-1 text-white px-2 py-1 rounded-full text-xs font-medium" style={{backgroundColor: '#3b82f6'}}>
                              P4
                            </span>
                          ) : usuario.filial_id === 'sao_paulo' ? (
                            <span className="inline-flex items-center gap-1 text-white px-2 py-1 rounded-full text-xs font-medium" style={{backgroundColor: '#22c55e'}}>
                              SP
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-1 bg-slate-100 text-slate-600 px-2 py-1 rounded-full text-xs font-medium">
                              Todas
                            </span>
                          )}
                        </TableCell>
                        <TableCell className="hidden lg:table-cell">
                          <span className="text-sm text-slate-600">{countPermissoes(usuario)}</span>
                        </TableCell>
                        {isSuperAdmin && (
                          <TableCell className="text-right">
                            <div className="flex justify-end gap-1">
                              <Button onClick={function() { openEditModal(usuario); }} variant="outline" size="sm" data-testid={'edit-user-' + usuario.id} className="h-8 w-8 p-0">
                                <Edit2 className="w-4 h-4" />
                              </Button>
                              {usuario.id !== currentUser.id && (
                                <Button 
                                  onClick={function() { setSelectedUsuario(usuario); setDeleteModalOpen(true); }} 
                                  variant="outline" 
                                  size="sm" 
                                  className="text-red-500 hover:text-red-600 h-8 w-8 p-0"
                                  data-testid={'delete-user-' + usuario.id}
                                >
                                  <Trash2 className="w-4 h-4" />
                                </Button>
                              )}
                            </div>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
                  {usuarios.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={isSuperAdmin ? 5 : 4} className="text-center py-8 text-slate-500">
                        Nenhum usuário encontrado
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Modal de Criar/Editar */}
      <Dialog open={modalOpen} onOpenChange={setModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{selectedUsuario ? 'Editar Usuário' : 'Novo Usuário'}</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="name">Nome Completo</Label>
                <Input 
                  id="name" 
                  value={formData.name} 
                  onChange={function(e) { setFormData(Object.assign({}, formData, { name: e.target.value })); }}
                  placeholder="Nome do usuário"
                  required 
                  data-testid="user-name-input"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="username">Email/Login</Label>
                <Input 
                  id="username" 
                  type="email"
                  value={formData.username} 
                  onChange={function(e) { setFormData(Object.assign({}, formData, { username: e.target.value })); }}
                  placeholder="email@exemplo.com"
                  required
                  disabled={!!selectedUsuario}
                  data-testid="user-username-input"
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="password">{selectedUsuario ? 'Nova Senha (deixe em branco para manter)' : 'Senha'}</Label>
              <div className="relative">
                <Input 
                  id="password" 
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password} 
                  onChange={function(e) { setFormData(Object.assign({}, formData, { password: e.target.value })); }}
                  placeholder={selectedUsuario ? '••••••••' : 'Digite a senha'}
                  required={!selectedUsuario}
                  data-testid="user-password-input"
                />
                <button 
                  type="button" 
                  onClick={function() { setShowPassword(!showPassword); }}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {/* Dados do Colaborador */}
            <div className="border-t pt-4">
              <h3 className="text-sm font-semibold text-slate-600 mb-3">Dados do Colaborador</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="cargo">Cargo/Função</Label>
                  <select 
                    id="cargo"
                    value={formData.cargo} 
                    onChange={function(e) { setFormData(Object.assign({}, formData, { cargo: e.target.value })); }}
                    className="w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
                    data-testid="user-cargo-select"
                  >
                    <option value="">Selecione...</option>
                    {CARGOS.map(function(c) { return <option key={c.value} value={c.value}>{c.label}</option>; })}
                  </select>
                </div>
                <div className="space-y-2">
                  <Label htmlFor="filial_id">Filial</Label>
                  <select 
                    id="filial_id"
                    value={formData.filial_id || ''} 
                    onChange={function(e) { setFormData(Object.assign({}, formData, { filial_id: e.target.value })); }}
                    className="w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
                    data-testid="user-filial-select"
                  >
                    <option value="">Todas as Filiais</option>
                    <option value="passa_quatro">🔵 Passa Quatro (P4)</option>
                    <option value="sao_paulo">🟢 São Paulo (SP)</option>
                  </select>
                </div>
                <div className="space-y-2">
                  <Label htmlFor="telefone">Telefone</Label>
                  <Input 
                    id="telefone" 
                    value={formData.telefone} 
                    onChange={function(e) { setFormData(Object.assign({}, formData, { telefone: e.target.value })); }}
                    placeholder="(00) 00000-0000"
                    data-testid="user-telefone-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="whatsapp_numero">WhatsApp</Label>
                  <Input 
                    id="whatsapp_numero" 
                    value={formData.whatsapp_numero} 
                    onChange={function(e) { setFormData(Object.assign({}, formData, { whatsapp_numero: e.target.value })); }}
                    placeholder="(00) 00000-0000"
                    data-testid="user-whatsapp-input"
                  />
                </div>
              </div>
            </div>

            {/* Configuração de Rastreio - Sistema migrado para Traccar */}
            {isSuperAdmin && (
              <div className="border-t pt-4">
                <h3 className="text-sm font-semibold text-slate-600 mb-3 flex items-center gap-2">
                  <Navigation className="w-4 h-4" /> Rastreio GPS
                </h3>
                <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                  <p className="text-sm text-green-800 font-medium">Sistema de rastreio via Traccar</p>
                  <p className="text-xs text-green-700 mt-1">
                    O rastreamento GPS agora é feito pelo aplicativo Traccar Client instalado no celular do técnico.
                    Acesse a página "Rastreio" para visualizar as posições em tempo real.
                  </p>
                </div>
              </div>
            )}

            <div className="space-y-4 border-t pt-4">
              <div className="flex items-center justify-between">
                <Label className="text-base font-semibold">Tipo de Usuário</Label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox"
                    checked={formData.is_super_admin}
                    onChange={function(e) { 
                      setFormData(Object.assign({}, formData, { is_super_admin: e.target.checked }));
                      if (e.target.checked) toggleAllPermissoes(true);
                    }}
                    className="w-4 h-4 rounded border-slate-300"
                    data-testid="super-admin-checkbox"
                  />
                  <span className="flex items-center gap-1 text-sm">
                    <Crown className="w-4 h-4 text-orange-500" /> Super Admin
                  </span>
                </label>
              </div>
              
              {!formData.is_super_admin && (
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <Label className="text-sm font-medium">Permissões de Acesso</Label>
                    <div className="flex gap-2">
                      <Button type="button" variant="outline" size="sm" onClick={function() { toggleAllPermissoes(true); }}>
                        <Check className="w-3 h-3 mr-1" /> Marcar Todos
                      </Button>
                      <Button type="button" variant="outline" size="sm" onClick={function() { toggleAllPermissoes(false); }}>
                        <X className="w-3 h-3 mr-1" /> Desmarcar Todos
                      </Button>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    {MODULOS.map(function(modulo) {
                      return (
                        <label key={modulo.key} className="flex items-center gap-2 cursor-pointer p-2 rounded-lg hover:bg-slate-50 border">
                          <input 
                            type="checkbox"
                            checked={formData.permissoes[modulo.key] || false}
                            onChange={function() { togglePermissao(modulo.key); }}
                            className="w-4 h-4 rounded border-slate-300 text-blue-600"
                            data-testid={'perm-' + modulo.key}
                          />
                          <span className="text-sm">{modulo.label}</span>
                        </label>
                      );
                    })}
                  </div>
                  
                  {/* Permissão de Rastreio GPS */}
                  <div className="mt-4 p-4 bg-green-50 rounded-lg border border-green-200">
                    <Label className="text-sm font-medium text-green-800 mb-2 block">Permissão de Rastreio GPS (Traccar)</Label>
                    <select
                      value={formData.permissoes.rastreio || 'sem_acesso'}
                      onChange={function(e) {
                        var newPermissoes = Object.assign({}, formData.permissoes, { rastreio: e.target.value });
                        setFormData(Object.assign({}, formData, { permissoes: newPermissoes }));
                      }}
                      className="w-full h-10 rounded-md border border-green-300 bg-white px-3 text-sm"
                      data-testid="perm-rastreio-select"
                    >
                      <option value="sem_acesso">Sem acesso</option>
                      <option value="ver_apenas_si">Ver apenas sua própria localização</option>
                      <option value="ver_todos">Ver todos os dispositivos</option>
                    </select>
                    <p className="text-xs text-green-600 mt-1">
                      Define o que o usuário pode visualizar na página de Rastreio
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t">
              <Button type="button" variant="outline" onClick={function() { setModalOpen(false); }}>
                Cancelar
              </Button>
              <Button type="submit" className="bg-blue-600 hover:bg-blue-700" data-testid="save-user-btn">
                {selectedUsuario ? 'Salvar Alterações' : 'Criar Usuário'}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      {/* Modal de Confirmar Exclusão */}
      <Dialog open={deleteModalOpen} onOpenChange={setDeleteModalOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirmar Exclusão</DialogTitle>
          </DialogHeader>
          <p className="text-slate-600">
            Tem certeza que deseja excluir o usuário <strong>{selectedUsuario?.name}</strong>?
          </p>
          <p className="text-sm text-slate-500">Esta ação não pode ser desfeita.</p>
          <div className="flex justify-end gap-3 mt-4">
            <Button variant="outline" onClick={function() { setDeleteModalOpen(false); }}>
              Cancelar
            </Button>
            <Button onClick={handleDelete} className="bg-red-500 hover:bg-red-600" data-testid="confirm-delete-btn">
              Excluir
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default UsuariosPage;
